<div class="left-sidenav" [ngClass]="{ 'custom-background': isCustomBackground }">
  <!-- LOGO -->
  <div class="brand">
    <a href="index.html" class="logo">
      <span>
        <img [src]="themeService.isDark ? 'assets/Menu sections/GAVAN_PASS_LOGO_DARK.svg' : 'assets/Menu sections/GAVAN_PASS_LOGO.svg'" />
      </span>
    </a>
  </div>
  <div class="company-selector px-3">
    <!-- <div class="btn-group">
      <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <img class="somatech-icon" src="./assets/Menu sections/Nick.png" alt=""> <span
          class="somatech ms-2">{{companyName}}</span>
      </button>
    </div>
  </div> -->
    <!--end logo-->
    <div class="menu-content h-100" data-simplebar="init">
      <div class="top-menu">
        <ul class="main-list">
          <li *ngFor="let val of menuList" class="parent-list">
            <div [ngClass]="val.menu_opened ? 'colored-menu' : 'non-colored'" class="d-flex align-items-center"
              [class.menu-item-off]="val.disabled"
              [title]="val.disabled ? 'Module disabled for this organisation' : null"
              role="button" [attr.aria-expanded]="val.submenu ? val.showSubmenu : null"
              [attr.aria-disabled]="val.disabled ? true : null" [attr.tabindex]="val.disabled ? -1 : 0"
              (click)="toggleMenu(val)" (keydown.enter)="toggleMenu(val)" (keydown.space)="$event.preventDefault(); toggleMenu(val)">
              <img *ngIf="val.menu_opened; else closedImage" class="sidebar-icon mx-2"
                src="./assets/Menu sections/{{ val.openedImage }}" width="12%" />
              <ng-template #closedImage>
                <img class="sidebar-icon mx-2" src="./assets/Menu sections/{{ val.icon }}" width="12%" />
              </ng-template>
              <span class="sidebar-menu ms-1" [ngClass]="val.menu_opened ? 'open-menu' : 'close-menu' ">
                {{ val.title }}
              </span>
              <span *ngIf="val.submenu" class="submenu-chevron ms-auto travel_management_icons"></span>
              <span *ngIf="val.disabled" class="off-badge">OFF</span>
            </div>

            <!-- Submenu -->
            <ul *ngIf="val.showSubmenu" class="submenu-list">
              <ng-container *ngFor="let subItem of val.submenu">
                <li class="parent-list">
                  <div class="d-flex align-items-center py-1 ms-4" [class.menu-item-off]="subItem.disabled"
                    [title]="subItem.disabled ? 'Module disabled for this organisation' : null"
                    [routerLink]="subItem.disabled ? null : subItem.url"
                    role="link" [attr.aria-disabled]="subItem.disabled ? true : null" [attr.tabindex]="subItem.disabled ? -1 : 0"
                    (click)="toggleSubMenu(subItem)" (keydown.enter)="toggleSubMenu(subItem)">
                    <img *ngIf="subItem.menu_opened; else subClosedImage" class="sidebar-icon me-2"
                      src="./assets/Menu sections/{{ subItem.openedImage }}" width="12%" />
                    <ng-template #subClosedImage>
                      <img class="sidebar-icon me-2" src="./assets/Menu sections/{{ subItem.icon }}" width="12%" />
                    </ng-template>
                    <a class="" [ngClass]="subItem.menu_opened ? 'subItem-colored' : 'subItem-black'">
                      {{ subItem.title }}
                    </a>
                    <span *ngIf="subItem.disabled" class="off-badge">OFF</span>
                  </div>
                </li>
              </ng-container>
            </ul>
          </li>
        </ul>
      </div>
      <div class="bottom-menu p-2">
        <div class="accordion">
          <details>
            <summary>Customer support</summary>
            <div class="content">
              <a href="tel:+254767902" class="support-row">
                <img class="sidebar-icon" src="./assets/Menu sections/phoneIcon.png" />
                <span class="sidebar-menu">Call +254767902</span>
              </a>
              <a href="mailto:corporate@buupass.com" class="support-row">
                <img class="sidebar-icon" src="./assets/Menu sections/email.png" />
                <span class="sidebar-menu">corporate&#64;buupass.com</span>
              </a>
            </div>
          </details>
        </div>
        <!-- <div class="dropdown">
        <button class="btn dropdown-toggle header_dropdown sidebar-menu" type="button" aria-expanded="false"
          (click)="showCustomerCare()">
          <img width="16" src="./assets/Menu sections/chat.png" alt="">
          Customer Support <img class="mx-3" width="16" src="./assets/Menu sections/dropdown-side.png" alt="">
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1"
          [ngClass]="{'see-modal': !showCustomerCareInfo, 'hide-modal' : showCustomerCareInfo }">
          <li class="parent-list">
            <img class="sidebar-icon mx-1" src="./assets/Menu sections/phoneIcon.png" width="12%" />
            <span class="sidebar-menu ms-2">
              Call +254767902
            </span>
          </li>
          <li class="parent-list">
            <img class="sidebar-icon mx-1" src="./assets/Menu sections/email.png" width="12%" />
            <span class="sidebar-menu ms-2">
              corporate&#64;buupass.com
            </span>
          </li>
        </ul>
      </div> -->
        <ul class="main-list">
          <li *ngFor="let val of bottomMenuList" class="parent-list mx-2" routerLink="{{ val.url }}"
            (click)="auth.logout()">
            <div class="d-flex align-items-center">
              <img class="sidebar-icon mx-1" src="./assets/Menu sections/{{ val.icon }}" width="12%" />
              <span class="sidebar-menu ms-2">
                Logout
              </span>
            </div>
          </li>
        </ul>


        <!--<div class="row">
        <div class="col-md-6 dark_btn">
          <li class="parent-list">
            <img class="sidebar-icon ms-2" src="./assets/Menu sections/half  moon.png" width="12%">

            <span class="sidebar-menu" >
              Light
            </span>
          </li>

        </div>


        <div class="col-md-6 dark_btn">

          <li class="parent-list">
            <img class="sidebar-icon mx-1" src="./assets/Menu sections/sun.png" width="12%" />

            <span class="sidebar-menu">
              Dark
            </span>
          </li>

        </div>
      </div>-->
      </div>
    </div>

  </div>